import {
  RoutingSupervisorApi,
  type AssignDoctorToConsultationRequestDTO,
  type SearchUsersResponse
} from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class RoutingSupervisorService {
  static readonly routingSupervisorApi = new RoutingSupervisorApi(globalApiConfig)

  static async getDoctorsAvailableForConsultationRequestAssignment(
    consultationRequestId: string
  ): Promise<SearchUsersResponse> {
    return (
      await RoutingSupervisorService.routingSupervisorApi.getDoctorsAvailableForConsultationRequestAssignment(
        consultationRequestId
      )
    ).data
  }

  static async assignDoctorToConsultationRequest(
    consultationRequestId: string,
    assignDoctorPayload: AssignDoctorToConsultationRequestDTO
  ): Promise<void> {
    await RoutingSupervisorService.routingSupervisorApi.putAssignDoctorToConsultationRequest(
      consultationRequestId,
      assignDoctorPayload
    )
  }
}
